import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from './api/hooks';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { QuotesPage } from './pages/QuotesPage';
import { NewQuotePage } from './pages/NewQuotePage';
import { CreatePage } from './pages/CreatePage';
import { ProposalPage } from './pages/ProposalPage';
import { QuoteDetailPage } from './pages/QuoteDetailPage';
import { NewCustomerPage } from './pages/NewCustomerPage';
import { NewItemPage } from './pages/NewItemPage';
import { NewSupplierPage } from './pages/NewSupplierPage';
import { ItemsPage } from './pages/ItemsPage';
import { CustomersPage } from './pages/CustomersPage';
import { AdminUsersPage } from './pages/AdminUsersPage';

export function App() {
  const me = useMe();

  if (me.isLoading) {
    return (
      <div className="center-screen">
        <p className="muted">Loading…</p>
      </div>
    );
  }

  const user = me.data?.user ?? null;

  return (
    <Routes>
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      {!user ? (
        <Route path="*" element={<LoginPage />} />
      ) : (
        <Route element={<Layout user={user} />}>
          <Route index element={<QuotesPage />} />
          <Route path="create" element={<CreatePage />} />
          <Route path="proposal" element={<ProposalPage />} />
          <Route path="quotes/new" element={<NewQuotePage />} />
          <Route path="quotes/:id" element={<QuoteDetailPage />} />
          <Route path="items" element={<ItemsPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/new" element={<NewCustomerPage />} />
          <Route path="items/new" element={<NewItemPage />} />
          <Route path="suppliers/new" element={<NewSupplierPage />} />
          {user.role === 'approver' && <Route path="admin/users" element={<AdminUsersPage />} />}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      )}
    </Routes>
  );
}
